module.exports = __webpack_public_path__ + "img/catalogue1.1311c879.png";